import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_ds_flatten_data_source_example_dataService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: {  }): 
  Promise<{ result: { Id?: number, LookupCode?: string, PackagingLookups?: { PackagingId?: number, IsBasePackaging?: boolean, ShippingWeight?: number, Weight?: number, WeightUomId?: number, Packaging?: { ShortName?: string }, WeightUom?: { Short_name?: string }, BasePackaging?: { ShortName?: string } }[] }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = null;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, PackagingLookups?: { PackagingId?: number, IsBasePackaging?: boolean, ShippingWeight?: number, Weight?: number, WeightUomId?: number, Packaging?: { ShortName?: string }, WeightUom?: { Short_name?: string }, BasePackaging?: { ShortName?: string } }[] }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, PackagingLookups?: { PackagingId?: number, IsBasePackaging?: boolean, ShippingWeight?: number, Weight?: number, WeightUomId?: number, Packaging?: { ShortName?: string }, WeightUom?: { Short_name?: string }, BasePackaging?: { ShortName?: string } }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      }) {
      return false;
    }
}
